// Wraps the first case-insensitive occurrence of `query` inside `text` in a
// <mark> styled like the design's `.syn-mark` (amber background, rounded). When
// the query is empty or has no match, the text renders verbatim.

interface HighlightMatchProps {
  text: string;
  query: string;
}

export function HighlightMatch({ text, query }: HighlightMatchProps) {
  const q = query.trim();
  if (!q) return <>{text}</>;
  const i = text.toLowerCase().indexOf(q.toLowerCase());
  if (i < 0) return <>{text}</>;
  // Use the matched slice length from the source text so casing is preserved.
  const before = text.slice(0, i);
  const match = text.slice(i, i + q.length);
  const after = text.slice(i + q.length);
  return (
    <>
      {before}
      <mark className="rounded-[3px] bg-warn-bg px-[1.5px] font-semibold text-warn">{match}</mark>
      {after}
    </>
  );
}
